import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpClientModule} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { KardexResponse } from '../modelos/kardex';

@Injectable({
    providedIn: 'root'
  })
  export class KardexService {
  
    
    httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
  
    constructor(private http:HttpClient) {
  
        
    }

    
    GetByCuid(Cuid:string ){

      return this.http.get<KardexResponse>(environment.URL_BACKEND + 'Kardex/ObtenerPorCuid/'+Cuid)
        .pipe(
        retry(1),
        catchError(this.errorHandl)
        )

    }

    GetByNumKardex(Kardex:string ){

      return this.http.get<KardexResponse>(environment.URL_BACKEND + 'Kardex/ObtenerPorNumKardex/'+Kardex)
        .pipe(
        retry(1),
        catchError(this.errorHandl)
        )

    }

    GetKardexsPorDocumentoContratante(Params:any ){

      return this.http.post<KardexResponse>(environment.URL_BACKEND + 'Kardex/ObtenerKardexsPorDocumentoContratante/',Params)
        .pipe(
        retry(1),
        catchError(this.errorHandl)
        )

    }


    errorHandl(error) {
      let errorMessage = '';
      if(error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      console.log(errorMessage);
      return throwError(errorMessage);
    }
     


}